// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.business-context-error {
  margin: 16px 0;
  padding: 12px 16px;
  border: 1px solid #efc9a0;
  border-radius: 8px;
  background: #fff5e9;
  color: #6b3900;
}

.business-context-error p { margin: 0 0 12px; }
.business-context-error button { max-width: 100%; white-space: normal; }

.business-context-parent-container {
    display: flex;
    flex-direction: column;
    gap: 20px;
    max-width: 1100px;
}

.business-context-info-box {
    display: flex;
    align-items: center;
    flex-direction: row;
    gap: 20px;
    background-color: #5616ea25;
    border-radius: 10px;
    padding: 15px;
    padding-top: 12px;
    padding-bottom: 12px;
    line-height: 1.45;
    border-left: 5px solid #5616ea;
}

.business-context-info-icon {
    font-size: 32px;
    color: #5616ea;
    flex-shrink: 0;
}

.business-context-info-text {
    display: flex;
    align-items: left;
    flex-direction: column;
}

.business-context-info-text p {
    margin: 0;
    padding: 0;
}

.business-context-editor {
    display: flex;
    flex-direction: column;
    background-color: white;
    border: 1px solid #e5e7eb;
    border-radius: 10px;
    padding: 15px;
}

.warning-icon {
    font-size: 20px;
    flex-shrink: 0;
}

.warning-text {
    margin: 0;
    color: #554002;
    font-size: 14px;
}

.save-discard-buttons {
    display: flex;
    gap: 10px;
    margin-top: 15px;
}

.discard-widget-btn {
    padding: 10px 20px;
    background-color: transparent;
    color: #5616ea;
    border: 1px solid #5616ea;
    border-radius: 8px;
    font-size: 15px;
    font-weight: 600;
    cursor: pointer;
    transition: background-color 0.2s ease, transform 0.2s ease;
}

.discard-widget-btn:hover {
    background-color: #f3eaff;
    transform: translateY(-1px);
}

/* "Regenerate from knowledge" (02.11.2026): right end of the Save row, and what came of it under the field */
.business-context-generate { margin-left: auto; display: inline-flex; }
.business-context-generate-btn {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 7px 14px 8px;
  background: #fff;
  color: #5616ea;
  border: 1px solid #5616ea;
  border-radius: 10px;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.2s ease, transform 0.2s ease;
}
.business-context-generate-btn:hover:not(:disabled) { background-color: #f3eaff; transform: translateY(-1px); }
.business-context-generate-btn:disabled { opacity: 0.5; cursor: not-allowed; }

.business-context-gen-note {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  margin: 4px 0 2px;
  padding: 12px 16px;
  border-radius: 8px;
  font-size: 14px;
  line-height: 1.45;
}
.business-context-gen-note.is-ok { background: #5616ea12; border: 1px solid #5616ea40; color: #2b1a5c; }
.business-context-gen-note.is-warn { background: #fff5e9; border: 1px solid #efc9a0; color: #6b3900; }
.business-context-gen-note-icon { flex-shrink: 0; margin-top: 3px; color: #5616ea; }
.business-context-gen-note.is-warn .business-context-gen-note-icon { color: #d97a1f; }
.business-context-gen-link {
  padding: 0;
  border: none;
  background: none;
  color: #5616ea;
  font: inherit;
  font-weight: 600;
  text-decoration: underline;
  text-underline-offset: 2px;
  cursor: pointer;
}

@media (max-width: 600px) {
  .save-discard-buttons { flex-wrap: wrap; }
  .business-context-generate { margin-left: 0; }
}
`, "",{"version":3,"sources":["webpack://./src/components/businessContext.css"],"names":[],"mappings":"AAAA;EACE,cAAc;EACd,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;AAChB;;AAEA,4BAA4B,gBAAgB,EAAE;AAC9C,iCAAiC,eAAe,EAAE,mBAAmB,EAAE;;AAEvE;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,SAAS;IACT,2BAA2B;IAC3B,mBAAmB;IACnB,aAAa;IACb,iBAAiB;IACjB,oBAAoB;IACpB,iBAAiB;IACjB,8BAA8B;AAClC;;AAEA;IACI,eAAe;IACf,cAAc;IACd,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,iBAAiB;IACjB,sBAAsB;AAC1B;;AAEA;IACI,SAAS;IACT,UAAU;AACd;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,yBAAyB;IACzB,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,SAAS;IACT,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,6BAA6B;IAC7B,cAAc;IACd,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,2DAA2D;AAC/D;;AAEA;IACI,yBAAyB;IACzB,2BAA2B;AAC/B;;AAEA,6GAA6G;AAC7G,6BAA6B,iBAAiB,EAAE,oBAAoB,EAAE;AACtE;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,qBAAqB;EACrB,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,2DAA2D;AAC7D;AACA,sDAAsD,yBAAyB,EAAE,2BAA2B,EAAE;AAC9G,0CAA0C,YAAY,EAAE,mBAAmB,EAAE;;AAE7E;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;AACnB;AACA,mCAAmC,qBAAqB,EAAE,2BAA2B,EAAE,cAAc,EAAE;AACvG,qCAAqC,mBAAmB,EAAE,yBAAyB,EAAE,cAAc,EAAE;AACrG,kCAAkC,cAAc,EAAE,eAAe,EAAE,cAAc,EAAE;AACnF,qEAAqE,cAAc,EAAE;AACrF;EACE,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,gBAAgB;EAChB,0BAA0B;EAC1B,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;EACE,wBAAwB,eAAe,EAAE;EACzC,6BAA6B,cAAc,EAAE;AAC/C","sourcesContent":[".business-context-error {\r\n  margin: 16px 0;\r\n  padding: 12px 16px;\r\n  border: 1px solid #efc9a0;\r\n  border-radius: 8px;\r\n  background: #fff5e9;\r\n  color: #6b3900;\r\n}\r\n\r\n.business-context-error p { margin: 0 0 12px; }\r\n.business-context-error button { max-width: 100%; white-space: normal; }\r\n\r\n.business-context-parent-container {\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: 20px;\r\n    max-width: 1100px;\r\n}\r\n\r\n.business-context-info-box {\r\n    display: flex;\r\n    align-items: center;\r\n    flex-direction: row;\r\n    gap: 20px;\r\n    background-color: #5616ea25;\r\n    border-radius: 10px;\r\n    padding: 15px;\r\n    padding-top: 12px;\r\n    padding-bottom: 12px;\r\n    line-height: 1.45;\r\n    border-left: 5px solid #5616ea;\r\n}\r\n\r\n.business-context-info-icon {\r\n    font-size: 32px;\r\n    color: #5616ea;\r\n    flex-shrink: 0;\r\n}\r\n\r\n.business-context-info-text {\r\n    display: flex;\r\n    align-items: left;\r\n    flex-direction: column;\r\n}\r\n\r\n.business-context-info-text p {\r\n    margin: 0;\r\n    padding: 0;\r\n}\r\n\r\n.business-context-editor {\r\n    display: flex;\r\n    flex-direction: column;\r\n    background-color: white;\r\n    border: 1px solid #e5e7eb;\r\n    border-radius: 10px;\r\n    padding: 15px;\r\n}\r\n\r\n.warning-icon {\r\n    font-size: 20px;\r\n    flex-shrink: 0;\r\n}\r\n\r\n.warning-text {\r\n    margin: 0;\r\n    color: #554002;\r\n    font-size: 14px;\r\n}\r\n\r\n.save-discard-buttons {\r\n    display: flex;\r\n    gap: 10px;\r\n    margin-top: 15px;\r\n}\r\n\r\n.discard-widget-btn {\r\n    padding: 10px 20px;\r\n    background-color: transparent;\r\n    color: #5616ea;\r\n    border: 1px solid #5616ea;\r\n    border-radius: 8px;\r\n    font-size: 15px;\r\n    font-weight: 600;\r\n    cursor: pointer;\r\n    transition: background-color 0.2s ease, transform 0.2s ease;\r\n}\r\n\r\n.discard-widget-btn:hover {\r\n    background-color: #f3eaff;\r\n    transform: translateY(-1px);\r\n}\r\n\r\n/* \"Regenerate from knowledge\" (02.11.2026): right end of the Save row, and what came of it under the field */\r\n.business-context-generate { margin-left: auto; display: inline-flex; }\r\n.business-context-generate-btn {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n  padding: 7px 14px 8px;\r\n  background: #fff;\r\n  color: #5616ea;\r\n  border: 1px solid #5616ea;\r\n  border-radius: 10px;\r\n  font-size: 15px;\r\n  font-weight: 600;\r\n  cursor: pointer;\r\n  transition: background-color 0.2s ease, transform 0.2s ease;\r\n}\r\n.business-context-generate-btn:hover:not(:disabled) { background-color: #f3eaff; transform: translateY(-1px); }\r\n.business-context-generate-btn:disabled { opacity: 0.5; cursor: not-allowed; }\r\n\r\n.business-context-gen-note {\r\n  display: flex;\r\n  align-items: flex-start;\r\n  gap: 10px;\r\n  margin: 4px 0 2px;\r\n  padding: 12px 16px;\r\n  border-radius: 8px;\r\n  font-size: 14px;\r\n  line-height: 1.45;\r\n}\r\n.business-context-gen-note.is-ok { background: #5616ea12; border: 1px solid #5616ea40; color: #2b1a5c; }\r\n.business-context-gen-note.is-warn { background: #fff5e9; border: 1px solid #efc9a0; color: #6b3900; }\r\n.business-context-gen-note-icon { flex-shrink: 0; margin-top: 3px; color: #5616ea; }\r\n.business-context-gen-note.is-warn .business-context-gen-note-icon { color: #d97a1f; }\r\n.business-context-gen-link {\r\n  padding: 0;\r\n  border: none;\r\n  background: none;\r\n  color: #5616ea;\r\n  font: inherit;\r\n  font-weight: 600;\r\n  text-decoration: underline;\r\n  text-underline-offset: 2px;\r\n  cursor: pointer;\r\n}\r\n\r\n@media (max-width: 600px) {\r\n  .save-discard-buttons { flex-wrap: wrap; }\r\n  .business-context-generate { margin-left: 0; }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
